import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { RcTrans } from '@/components/atoms/RcTrans';

export const ArchivedChatView = () => (
  <Paper
    elevation={3}
    sx={theme => ({
      borderRadius: 1,
      mx: 4,
      p: 4,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    })}
  >
    <Typography variant='h4' color='text.primary' textAlign='center'>
      <RcTrans i18nKey='shared.chat-archived' />
    </Typography>
    <Typography
      variant='subtitle2'
      color='text.secondary'
      textAlign='center'
    >
      <RcTrans i18nKey='shared.chat-archived-subtitle' />
    </Typography>
  </Paper>
);
